/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/review/';
	let basePath = location.pathname.includes('/mens/') === true ? '/mens' : '';

	// JSON取得 ===============================================
	// エリアJSON
	const returnAreaAll = (_path) => {
		return `${_path}/ajax/review/area/all/area.json`;
	}
	// 都道府県JSON
	const returnPrefAll = (_path) => {
		return `${_path}/ajax/review/pref/all/pref.json`;
	};
	
	// ============ ↓↓ FUNCTIONS ↓↓ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const mainVisSwiper = () => {
		const mainVis = document.querySelector('.js-pickup-slider');

		if(mainVis) {
			const prevButton = mainVis.querySelector('.splide-arrow-prev');
			const nextButton = mainVis.querySelector('.splide-arrow-next');

			const splide = new Splide(mainVis, {
				type: 'loop',
				perPage: 3,
				gap: 24,
				autoplay: false,
				speed: 500,
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
				flickMaxPages: 1,
                flickPower: 100,
                snap: true,
                drag: true,
				breakpoints: {
					1024: {
						perPage: 2,
					},
					768: {
						perPage: 1,
						gap: 16,
					}
				}
			});

			splide.mount();

			if (prevButton && nextButton) {
				prevButton.addEventListener('click', () => {
					// '前へ' ボタンがクリックされたら、前のスライドへ移動
					splide.go('<');
				});

				nextButton.addEventListener('click', () => {
					// '次へ' ボタンがクリックされたら、次のスライドへ移動
					splide.go('>');
				});
			}
		}
	};

	// <全国のお客様の声>エリアリスト生成
	const createAreaList = async () => {
		const areaListWrap = document.querySelector('.js-review-areaList');
		if(areaListWrap) {
			// エリアブロックのテンプレート
			let componentsAreaBlock = await fetch('/cnt_common/js/html/review-area-list.html').then(res => res.text());
			// 都道府県リンクのテンプレート
			let componentsPrefItem = await fetch('/cnt_common/js/html/shop-area-list-item.html').then(res => res.text());
			let areaListHtml = '';

			fetch(returnPrefAll(basePath))
				.then(response => response.json())
				.then((data) => {
					const prefData = data.rt_bn_review_pref_json;
					prefList = prefData;
					
					// prefListが設定された後に、エリアデータを取得する
					return fetch(returnAreaAll(basePath));
				})
				.then(response => response.json())
				.then((data) => {
					const areaData = data.rt_bn_review_area_json;
					if (areaData.length) {
						for (let i = 0; i < areaData.length; i++) {
							let thisAreaData = areaData[i].cf_r_area;
							let areaKey = thisAreaData._key;
							let areaName = basePath === '/mens' ? areaData[i].rt_cf_sa_name_mens.content : thisAreaData.cf_sa_name;
							let prefHtml = '';
							let listClass = basePath === '/mens' ? '_mens' : '';

							for (let i = 0; i < prefList.length; i++) {
								if (prefList[i].cf_r_area._key === areaKey) {
									let prefkey = prefList[i].cf_r_prefecture._key;
									let prefName = prefList[i].cf_r_prefecture.cf_sp_name;
									let prefHref = basePath === '/mens' ? `/mens/review/area/${prefkey}/` : `/review/area/${prefkey}/`;

									prefHtml += componentsPrefItem
										.replaceAll('{!prefLink!}', prefHref)
										.replaceAll('{!prefName!}', prefName);
								}
							};

							areaListHtml += componentsAreaBlock
								.replaceAll('{!areaKey!}', areaKey)
								.replaceAll('{!areaName!}', areaName)
								.replaceAll('{!class!}', listClass)
								.replaceAll('{!items!}', prefHtml);
						}
					}
					
					// HTML反映
					areaListWrap.innerHTML = areaListHtml;
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		}
	};


	// 他のお客様の声 インタビュー　現在見ているページを非表示
	const reviewOtherItems = () => {
		const otherSlider = document.querySelector('.js-review-other-slider');
		if (otherSlider) {
			const listContainer = otherSlider.querySelector('.splide__list');
			if (!listContainer) return;
			
			// Remove the current page item
			otherSlider.querySelectorAll('.interview-list-item').forEach((item) => {
				if(item.querySelector('a')?.href === window.location.href) {
					item.remove();
				}
			});
			
			// Get all remaining items
			const remainingItems = Array.from(otherSlider.querySelectorAll('.interview-list-item'));
			
			// Shuffle the array using Fisher-Yates algorithm
			for (let i = remainingItems.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[remainingItems[i], remainingItems[j]] = [remainingItems[j], remainingItems[i]];
			}
			
			// Remove all items from DOM
			remainingItems.forEach(item => item.remove());
			
			// Append items back in shuffled order
			remainingItems.forEach(item => {
				listContainer.appendChild(item);
			});
		}
	};

	// 他のお客様の声 インタビュー　スライダー
	const reviewOtherSwiper = () => {
		const reviewOther = document.querySelector('.js-review-other-slider');

		if(reviewOther) {
			const prevButton = reviewOther.querySelector('.splide-arrow-prev');
			const nextButton = reviewOther.querySelector('.splide-arrow-next');
			const splide = new Splide(reviewOther, {
				//type: 'loop',
				perPage: 3,
				gap: 24,
				autoplay: false,
				speed: 500,
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
				flickMaxPages: 1,
                flickPower: 100,
                snap: true,
                drag: true,
				breakpoints: {
	 				1024: {
						perPage: 2,
					},
					768: {
						perPage: 1,
						gap: 16,
					}
				}
			});

			splide.mount();

			if (prevButton && nextButton) {
				prevButton.addEventListener('click', () => {
					// '前へ' ボタンがクリックされたら、前のスライドへ移動
					splide.go('<');
				});

				nextButton.addEventListener('click', () => {
					// '次へ' ボタンがクリックされたら、次のスライドへ移動
					splide.go('>');
				});
			}
		}
	};


	// ============ ↑↑ FUNCTIONS ↑↑ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const newsFUNCTIONS = () => {
		createAreaList();
		mainVisSwiper();
		reviewOtherItems();
		reviewOtherSwiper();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
